import type { FeedbackInputDto } from '@portals/shared/portal/FeedbackDto';

import { request } from '@/request';

export function submitFeedback(data: FeedbackInputDto) {
  return request('/feedback', 'post', data);
}
